import React, { useState } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { Input, Submit } from 'components/Form'
import './login.css'
import { useAuthentication } from 'hooks/authentication'
import { AUTHENTICATE } from 'operations/User'

import logo from './logo.png'

function Login() {

    const { setAuthenticated } = useAuthentication()

    const [ authenticate ] = useMutation(AUTHENTICATE)

    const [inputs, setInputs] = useState({
        username: '',
        password: ''
    })

    function handleChange({ target: { name, value } }) {
        // this.setState({
        //     [name]: value
        // })
        setInputs(inputs => ({
            ...inputs,
            [name]: value
        }))
    }
    
    return (
        <React.Fragment>
            <div className="login-wrapper">
                <div style={{maxWidth:'600px', margin:'100px auto'}}>
                <form onSubmit={async (e) => {
                    e.preventDefault()

                    const { username, password } = inputs

                    try {
                        const { data: { authenticate: { accessToken, refreshToken } } } = await authenticate({
                            variables: {
                                payload: {
                                    username,
                                    password
                                }
                            }
                        })
                    
                        localStorage.setItem('accessToken', accessToken)
                        localStorage.setItem('refreshToken', refreshToken)
                        setAuthenticated(true)

                    }
                    catch(err) {
                        console.log(err)
                    }

                }}>
                        <div style={{textAlign:'center'}}>
                    <img src={logo} alt='Automotive Intelligence Mapping System' style={{margin:'0px auto'}}/>
                    </div>
                    <h2>Log in to your account</h2>
                        <Input type="text" name="username" label='Username' onChange={ handleChange } />
                        <Input type="password" name="password" label='Password' onChange={ handleChange } />
                    
                    <Submit value="Log in"/>
                </form>
            </div>
            </div>
            
        </React.Fragment>
    )
}

export default Login